export enum RoutePath {
  Home = '/',
  Login = '/login',
  Users = '/users',
  Assets = '/assets',
  Customers = '/customers',
  Sites = '/sites',
  Transactions = '/transactions',
  WhatsAppPreferences = '/whatsapp-preferences',
  EntityAliases = '/whatsapp-names',
}
